import React from 'react'
import PropTypes from 'prop-types'
import Dialog from '..'
import ButtonRounded from '../../ButtonRounded'
import styles from './styles'
import getLoginPortalUrl from '../../../utils/getLoginPortalUrl'

const LoginDialog = ({ currentDomain, currentUrl, center }) => (
  <div className={center ? 'LoginDialog center' : 'LoginDialog'}>
    <Dialog
      title="Sign in or Join to start watching"
      subtitle="Please sign in to your STV account. If you don't have an account, create one now for free."
    />
    <div className="button-container">
      <ButtonRounded
        fullWidth
        text="Sign in/Join"
        // eslint-disable-next-line max-len
        href={`${getLoginPortalUrl(currentDomain)}/?siteAction=remoteLogin&cid=int_stv_em_el_ctahpjoin&source=${encodeURIComponent(currentUrl)}`}
      />
    </div>
    <style jsx>{styles}</style>
  </div>
)

LoginDialog.propTypes = {
  currentUrl: PropTypes.string.isRequired,
  currentDomain: PropTypes.string.isRequired,
  center: PropTypes.bool,
}

LoginDialog.defaultProps = {
  center: false,
}

export default LoginDialog
